var map = {
	"./additionalInfoIcon.svg": 583,
	"./arrowLeftIcon.svg": 584,
	"./arrowMediumTop.svg": 585,
	"./arrowRightIcon.svg": 586,
	"./arrowRightIconSharp.svg": 587,
	"./arrowRightSmallIcon.svg": 588,
	"./arrowScalableIcon.svg": 589,
	"./arrowSelect2.svg": 590,
	"./arrowSelectIcon.svg": 591,
	"./benefit1.svg": 592,
	"./benefit2.svg": 593,
	"./benefit3.svg": 594,
	"./cardsIcon.svg": 595,
	"./copyIcon copy.svg": 596,
	"./copyIcon.svg": 597,
	"./crossIcon.svg": 598,
	"./crossIcon2.svg": 599,
	"./crossIcon3.svg": 600,
	"./crossIconSmall.svg": 601,
	"./crossSmallIcon.svg": 602,
	"./defaultCategoryIcon.svg": 603,
	"./depNumberIcon.svg": 604,
	"./elfCentralIcon.svg": 605,
	"./equalitySign.svg": 606,
	"./errorIcon.svg": 607,
	"./eyeClosedIcon.svg": 608,
	"./eyeOpenIcon.svg": 609,
	"./favoritesIcon.svg": 610,
	"./favoritesLabelIcon.svg": 611,
	"./filterDivider.svg": 612,
	"./filterIcon.svg": 613,
	"./frequencyIcon.svg": 614,
	"./fsAmountIcon.svg": 615,
	"./fullScreenIcon.svg": 616,
	"./gameIcon.svg": 617,
	"./hamburgerIcon.svg": 618,
	"./infoIcon.svg": 619,
	"./infoSymbol.svg": 620,
	"./levelBackground.svg": 621,
	"./levelBackgroundNew.svg": 622,
	"./linkIcon.svg": 623,
	"./lockIcon.svg": 624,
	"./lockSharpIcon.svg": 625,
	"./maxBonusAmountIcon.svg": 626,
	"./maxWinFsIcon.svg": 627,
	"./menu/fortuneIcon.svg": 353,
	"./menu/fortuneIconL.svg": 354,
	"./menu/helpdeskIcon.svg": 355,
	"./menu/helpdeskIconL.svg": 356,
	"./menu/homeIcon.svg": 357,
	"./menu/homeIconLarge.svg": 358,
	"./menu/jackpotIcon.svg": 359,
	"./menu/logo.svg": 360,
	"./menu/logoSmall.svg": 361,
	"./menu/loyaltyIcon.svg": 362,
	"./menu/mobileAppIcon.svg": 363,
	"./menu/profileIcon.svg": 364,
	"./menu/questIcon.svg": 365,
	"./menu/rewardLineupIcon.svg": 366,
	"./menu/searchIcon.svg": 367,
	"./menu/searchIconLarge.svg": 368,
	"./menu/signOutIcon.svg": 369,
	"./menu/star.svg": 370,
	"./menu/tournamentIcon.svg": 371,
	"./menu/tournamentLargeIcon.svg": 372,
	"./menu/vipIcon.svg": 373,
	"./menu/wheelIcon.svg": 374,
	"./menu/wheelIconL.svg": 375,
	"./menu/wheelIconMobile.svg": 376,
	"./menuIcon.svg": 628,
	"./minDepIcon.svg": 629,
	"./noTournamentIcon.svg": 630,
	"./numbers/number-1.svg": 377,
	"./numbers/number-2.svg": 378,
	"./numbers/number-3.svg": 379,
	"./numbers/number-4.svg": 380,
	"./numbers/number-5.svg": 381,
	"./numbers/number-6.svg": 382,
	"./numbers/number-7.svg": 383,
	"./numbers/number-8.svg": 384,
	"./numbers/number-9.svg": 385,
	"./numbers/number-shine-1.svg": 386,
	"./numbers/number-shine-2.svg": 387,
	"./numbers/number-shine-3.svg": 388,
	"./numbers/number-shine-4.svg": 389,
	"./numbers/number-shine-5.svg": 390,
	"./numbers/number-shine-6.svg": 391,
	"./numbers/number-shine-7.svg": 392,
	"./numbers/number-shine-8.svg": 393,
	"./numbers/number-shine-9.svg": 394,
	"./playIcon.svg": 631,
	"./polygon.svg": 632,
	"./preloaderDotsAnimation.svg": 633,
	"./preloaderSpinnerAnimation.svg": 634,
	"./presentIcon.svg": 635,
	"./promoIcon.svg": 636,
	"./recentIcon.svg": 637,
	"./search2Icon.svg": 638,
	"./search3Icon.svg": 639,
	"./sharpTickIcon copy.svg": 640,
	"./sharpTickIcon.svg": 641,
	"./smallInfoSymbol.svg": 642,
	"./smoothArrowIcon.svg": 643,
	"./successIcon.svg": 644,
	"./supportIcon.svg": 645,
	"./tag1Icon.svg": 646,
	"./tag2Icon.svg": 647,
	"./tag3Icon.svg": 648,
	"./tag4Icon.svg": 649,
	"./tickIcon.svg": 650,
	"./unverified.svg": 651,
	"./verified.svg": 652,
	"./wagerIcon.svg": 653,
	"./wagerTimeIcon.svg": 654,
	"./warningIcon.svg": 655
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 582;